import { render, staticRenderFns } from "./ticket_reference_types.vue?vue&type=template&id=2fe5acca&scoped=true&"
import script from "./ticket_reference_types.vue?vue&type=script&lang=js&"
export * from "./ticket_reference_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe5acca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fe5acca')) {
      api.createRecord('2fe5acca', component.options)
    } else {
      api.reload('2fe5acca', component.options)
    }
    module.hot.accept("./ticket_reference_types.vue?vue&type=template&id=2fe5acca&scoped=true&", function () {
      api.rerender('2fe5acca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/ticket_reference_types.vue"
export default component.exports